"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTSProvider = void 0;
var TTSProvider;
(function (TTSProvider) {
    TTSProvider["OpenAI"] = "OpenAI";
    TTSProvider["Polly"] = "Polly";
})(TTSProvider || (exports.TTSProvider = TTSProvider = {}));
